import Vue from 'vue'
import Router from 'vue-router'

import Loading from '../components/Loading.vue'
import Start from '../components/Start.vue'
import Choice from '../components/Choice.vue'
import Training from '../components/Training.vue'
import Congrats from '../components/Congrats.vue'

Vue.use(Router)

export default new Router({
    routes: [
        { path: '/', name: 'loading', component: Loading },
        { path: '/start', name: 'start', component: Start },
        { path: '/choice', name: 'choice', component: Choice },
        { path: '/training/:training_type/:step_number', name: 'training', component: Training },
        { path: '/congrats', name: 'congrats', component: Congrats },
    ],
    // mode: 'history'
})
